/**
 * Utilities to manage meta tags dynamically for SPA routes.
 * Note: Many link unfurlers don't execute JavaScript. This improves
 * in-browser sharing previews, but for perfect unfurls consider static routes.
 */

export type MetaPayload = {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
};

function setTag(attr: 'name' | 'property', key: string, value: string) {
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

export function updateMeta(meta: MetaPayload) {
  if (meta.title) {
    document.title = meta.title;
    setTag('property', 'og:title', meta.title);
    setTag('name', 'twitter:title', meta.title);
  }
  if (meta.description) {
    setTag('property', 'og:description', meta.description);
    setTag('name', 'twitter:description', meta.description);
  }
  if (meta.url) {
    setTag('property', 'og:url', meta.url);
  }
  if (meta.image) {
    setTag('property', 'og:image', meta.image);
    setTag('name', 'twitter:image', meta.image);
  }
}

